export interface ITelegramVars {
  chatId: string;
  dingChatId: string;
  botUsername: string;
  botId: string;
  botServiceApiKey: string;
}

const LogChannelChatId: string = '-1002880174595';
const DingChannelChatId: string = '-1003757969755';

export const telegramVars: ITelegramVars = {
  chatId: LogChannelChatId,
  dingChatId: DingChannelChatId,
  botUsername: 'coolmaterobot',
  botId: '8629082379',
  botServiceApiKey: 'tg-svc-9f3a7b2e1d5c8040',
};
